import React, { useEffect, useState } from "react";
import styles from "./companyvideo.scss";
import { useLocation, useParams, useHistory } from "react-router";
import request from '../../common/request';
import ReactPlayer from "react-player";

const CompanyVideo = () => {
    
    const location = useLocation();
    const params = useParams();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [vtour, setVtour] = useState(null);

    useEffect(() => {
        async function process() {
            if (vtour == null || (vtour !== null && vtour.slug != params.company)) {
                var tourData = await loadTourData();
            }
        }

        if (params.company) {
            console.log("params.company", params.company);
            process();
        }
    }, [location]);

    const loadTourData = async () => {
        setLoading(true);

        var result = await request
            .get("/api/virtual-tour/data")
            .query({
                slug: params.company,
            })
            .set("Accept", "application/json, text/javascript");

        setLoading(false);
        setVtour(result.body.tour);
        console.log("result.body.tour", result.body.tour);
    }

    return (
        <div className={styles.videoWrapper}>
            { vtour && vtour.companyVideo && (
                <ReactPlayer
                    url={`https://www.youtube.com/watch?v=${vtour.companyVideo}`}
                    config={{
                        youtube: {
                            playerVars: { 
                                showinfo: 0,
                                rel: 9,
                                modestbranding: 1,
                                controls: 1
                            }
                        },
                    }}
                    playsinline={true}
                    playing={true}
                    width="100%"
                    height="100%"
                    className={styles.playerWrapper}
                />
            )}
        </div>
    );

};

export { CompanyVideo };